<template>
  <div id="userManager">
    <div class="allMenuHead">
      <!-- <div :style="{'left': step ? '25px' : '125px'}"  class="moveLine p_a"></div>-->
      <div v-if="$childMenu.indexOf('HCP列表') >= 0" :class="step === 1 ? 'active' : ''" @click="toUrl('userList', 1)" class="d_i headTab p_r">HCP列表<div class="p_a"></div></div>
      <!-- <div v-if="showOther" :class="!step ? 'active' : ''" @click="toUrl('whiteList', 2)"  class="d_i headTab p_r">例外名单<div class="p_a"></div></div>-->
      <!-- <div v-else :class="!step ? 'active' : ''" @click="toUrl('whiteList', 2)"  class="d_i headTab p_r">白名单<div class="p_a"></div></div>-->
      <div v-if="$childMenu.indexOf('操作日志') >= 0" :class="step === 2 ? 'active' : ''" @click="toUrl('operationLogs', 2)" class="d_i headTab p_r">操作日志<div class="p_a"></div></div>
      <div v-if="$childMenu.indexOf('HCP列表') >= 0" :class="step === 3 ? 'active' : ''" @click="toUrl('nonHCPList', 3)" class="d_i headTab p_r">Non-HCP列表<div class="p_a"></div></div>
      <div v-if="$childMenu.indexOf('操作日志') >= 0" :class="step === 4 ? 'active' : ''" @click="toUrl('operationLogs_nonHCP', 4)" class="d_i headTab p_r">Non-HCP操作日志<div class="p_a"></div></div>
    </div>
    <div class="allHeaderRouter">
      <transition name="fadeLeft">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
let Time
export default {
  name: 'userManager',
  data () {
    return {
      step: 1,
      isSystemAdmin: window.sessionStorage.getItem('isSystemAdmin'),
      appowner: JSON.parse(window.sessionStorage.getItem('nowApp')),
      showOther: true
    }
  },
  created () {
    console.log(this.appowner)
    if (this.isSystemAdmin === 'true') {
      this.showOther = false
    }
    Time = setInterval(p => {
      if (window.location.href.indexOf('userList') >= 0) {
        this.step = 1
      } else if (window.location.href.indexOf('operationLogs') >= 0 && window.location.href.indexOf('operationLogs_nonHCP')<0) {
        this.step = 2
      } else if (window.location.href.indexOf('nonHCPList') >= 0) {
        this.step = 3
      } else if (window.location.href.indexOf('operationLogs_nonHCP') >= 0) {
        this.step = 4
      }
    }, 100)
  },
  destroyed () {
    clearInterval(Time)
  },
  methods: {
    toUrl (url, num) {
      // if (num === 1) {
      //   this.step = true
      // } else {
      //   this.step = false
      // }
      this.step = num
      this.$router.push({
        name: url
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/userManager/userManager.vue